module.exports = __webpack_public_path__ + "static/media/tutorial-dashboard-pin-2.363cf8ba.svg";